import { BookingDetails } from '../../types/booking-details.types';
import { TIMELINE_TYPE_CONFIG } from '../../constants/booking-details.constants';
import { cn } from '../../lib/utils';

export function TimelineTab({ booking }: { booking: BookingDetails }) {
  return (
    <div className="p-6">
      <h3 className="text-[11px] font-bold uppercase tracking-widest text-slate-400 mb-6">
        Historique de la réservation
      </h3>
      {booking.timeline && booking.timeline.length > 0 ? (
        <div className="relative">
          <div className="absolute left-[7px] top-2 bottom-2 w-px bg-slate-200" />
          <div className="space-y-6">
            {booking.timeline.map((event, idx) => {
              const config = TIMELINE_TYPE_CONFIG[event.type] || TIMELINE_TYPE_CONFIG.info;
              return (
                <div key={idx} className="flex gap-4 relative">
                  <div
                    className={cn(
                      'w-[15px] h-[15px] rounded-full border-2 border-white shrink-0 mt-0.5 relative z-10',
                      config.dotColor,
                    )}
                  />
                  <div className="flex-1">
                    <p className={cn('text-sm font-medium', config.color)}>{event.event}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{event.date}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="text-sm text-slate-500">Aucun événement enregistré.</p>
      )}
    </div>
  );
}
